import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import { selectUserInfo } from "modules/auth/authSlice";
import {
    selectSalesByProductSort,
    setSalesByProductSort,
    SalesByProductSortField
} from "modules/customer/tools/product/productSlice";
import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(25)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const clientName = useAppSelector(selectUserInfo).companyDisplayName;
    const salesByProductSort = useAppSelector(selectSalesByProductSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: SalesByProductSortField) => () => {
        let direction = SortDirection.ASC;
        if (salesByProductSort.field === field) {
            direction = salesByProductSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newSalesByProductSort = { ...salesByProductSort, field, direction };
        dispatch(setSalesByProductSort(newSalesByProductSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(SalesByProductSortField.OptimisedSales)} data-current={salesByProductSort.field === SalesByProductSortField.OptimisedSales}>
                    <Typography variant="body1" component="div">
                        Optimised sales
                    </Typography>
                    <Spacer />
                    {salesByProductSort.field !== SalesByProductSortField.OptimisedSales || salesByProductSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(SalesByProductSortField.EstimatedSales)} data-current={salesByProductSort.field === SalesByProductSortField.EstimatedSales}>
                    <Typography variant="body1" component="div">
                        Estimated sales
                    </Typography>
                    <Spacer />
                    {salesByProductSort.field !== SalesByProductSortField.EstimatedSales || salesByProductSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(SalesByProductSortField.ClientSourcedSales)} data-current={salesByProductSort.field === SalesByProductSortField.ClientSourcedSales}>
                    <Typography variant="body1" component="div">
                        {clientName} sourced sales
                    </Typography>
                    <Spacer />
                    {salesByProductSort.field !== SalesByProductSortField.ClientSourcedSales || salesByProductSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
